module.exports = __webpack_public_path__ + "static/media/IMG-13.cf66bcb3.jpg";